export default "__VITE_ASSET__XhgycAIu__"